module.exports = __webpack_public_path__ + "static/img/智慧网银云5.2c3ce7a5.png";